
import { FloatingFeature } from "@models";
import { DamageType } from "@dndModels/Types";
import { 
  // AbilityLimitation, 
  SpellLimitation,
  UpgradableNumber, 
  // WeaponLimitation 
} from "@dndModels/misc";
import { SpellOverrides, SpellsFromList } from "@dndModels/feature/SpellAsAbility";
import { ExtraEffectsFeature, ExtraEffectTypeFeature } from "@dndModels/feature/SystemFloatingFeature";

/**
 * This is for some features which allow the 
 * modification of specific spells.
 * Particularly it's for the numerous 
 * Eldritch Invocations which modify 
 * Eldritch Blast.
 */
export class SpellModifier extends FloatingFeature {
  spell_limit: SpellLimitation = new SpellLimitation();
  // modifies: "Spell DC" | "Attack" | "Damage" | "Range" | "Casting Time" | "Bonus Effect" | "Include Modifier" | "Minimum Damage" | "Damage Reroll" | "None" = "None";
  // formula: string = "";
  spell_overrides: SpellOverrides = new SpellOverrides();

  constructor(obj?: any) {
    super(obj);
    this.feature_type = "Spell Modifier";
    if (obj) {
      if (obj.spell_overrides && obj.spell_limit) {
        this.spell_limit = new SpellLimitation(obj.spell_limit);
        this.spell_overrides = new SpellOverrides(obj.spell_overrides);
      } else {
        let spell_id = "";
        let modifies = "";
        let formula = "";
        spell_id = obj.spell_id ? obj.spell_id : "";
        modifies = obj.modifies ? obj.modifies : "None";
        formula = obj.formula ? obj.formula : "";
        if (obj.spell_limit) {
          this.spell_limit = new SpellLimitation(obj.spell_limit);
        } else if (spell_id !== "") {
          this.spell_limit.spell_ids = [spell_id];
        }
        const formula_num = +formula;
        switch (modifies) {
          case "Spell DC":
            if (!isNaN(formula_num)) {
              this.spell_overrides.spell_dc = new UpgradableNumber(formula_num);
            }
          break;
          case "Attack":
            console.error("Not Implemented");
          break;
          case "Damage":
            console.error("Not Implemented");
          break;
          case "Range": 
            console.error("Not Implemented");
          break;
          case "Casting Time": 
            console.error("Not Implemented");
          break;
          case "Bonus Effect":
            console.error("Not Implemented");
          break; 
          case "Include Modifier":
            this.spell_overrides.include_modifier_on_damage = "True";
          break;
          case "Minimum Damage":
            if (!isNaN(formula_num)) {
              this.spell_overrides.minimum_damage_die_roll = formula_num;
              this.spell_overrides.max_dice_minned = 1;
            }
          break;
          case "Damage Reroll":
            if (!isNaN(formula_num)) {
              this.spell_overrides.damage_die_reroll_threshold = formula_num;
              this.spell_overrides.max_dice_rerolled = 1;
            }
          break;
        }
      }
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     if (obj.spell_overrides && obj.spell_limit) {
  //       this.spell_limit = new SpellLimitation(obj.spell_limit);
  //       this.spell_overrides = new SpellOverrides(obj.spell_overrides);
  //     } else {
  //       let spell_id = "";
  //       let modifies = "";
  //       let formula = "";
  //       spell_id = obj.spell_id ? obj.spell_id : "";
  //       modifies = obj.modifies ? obj.modifies : "None";
  //       formula = obj.formula ? obj.formula : "";
        
  //       if (obj.spell_limit) {
  //         this.spell_limit = new SpellLimitation(obj.spell_limit);
  //       } else if (spell_id !== "") {
  //         this.spell_limit.spell_ids = [spell_id];
  //       }
  //       const formula_num = +formula;
  //       switch (modifies) {
  //         case "Spell DC":
  //           if (!isNaN(formula_num)) {
  //             this.spell_overrides.spell_dc = new UpgradableNumber(formula_num);
  //           }
  //         break;
  //         case "Attack":
  //           console.error("Not Implemented");
  //         break;
  //         case "Damage":
  //           console.error("Not Implemented");
  //         break;
  //         case "Range": 
  //           console.error("Not Implemented");
  //         break;
  //         case "Casting Time": 
  //           console.error("Not Implemented");
  //         break;
  //         case "Bonus Effect":
  //           console.error("Not Implemented");
  //         break; 
  //         case "Include Modifier":
  //           this.spell_overrides.include_modifier_on_damage = "True";
  //         break;
  //         case "Minimum Damage":
  //           if (!isNaN(formula_num)) {
  //             this.spell_overrides.minimum_damage_die_roll = formula_num;
  //             this.spell_overrides.max_dice_minned = 1;
  //           }
  //         break;
  //         case "Damage Reroll":
  //           if (!isNaN(formula_num)) {
  //             this.spell_overrides.damage_die_reroll_threshold = formula_num;
  //             this.spell_overrides.max_dice_rerolled = 1;
  //           }
  //         break;
  //       }
  //     }
  //   }
  // }

  get consumed_resource() {
    return this.spell_overrides.consumed_resource;
  }

  get resource_consumed() {
    const slot_override = this.spell_overrides.slot_override;
    if (slot_override === "Don't Override") {
      return "Slot";
    }
    return this.spell_overrides.consumed_resource.resource_consumed;
  }

  get potence_class() {
    return this.spell_overrides.potence_class;
  }

  toDBObj(): any {
    const db_obj = super.toDBObj();
    return {
      ...db_obj,
      spell_limit: this.spell_limit.toDBObj(),
      spell_overrides: this.spell_overrides.toDBObj(),
    };
  }

  copy(copyMe: FloatingFeature, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    if (copyMe instanceof SpellModifier || copyMe instanceof SpellsFromList) {
      this.safe_copy(copyMe);
    } else {
      if (copyMe instanceof SpellDamageOptions || 
        copyMe instanceof ExtraEffectsFeature || 
        copyMe instanceof ExtraEffectTypeFeature) {
        this.spell_limit = copyMe.spell_limit.clone();
      }
    }
  }

  safe_copy(copyMe: SpellModifier) {
    this.spell_limit = copyMe.spell_limit.clone();
    this.spell_overrides = copyMe.spell_overrides.clone();
  }

  clone(drop_ids = false): SpellModifier {
    const new_obj = new SpellModifier();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}

/**
 * This is going to replace SpellModifier.  
 * It works the same, but can apply to Weapons, Abilities, or Spells, akin to ExtraEffects, 
 * but instead of adding extra effects, it modifies the main one.
 * 
 * This should only be used if it's something that affects every use of the thing. 
 * If not then it should be an Extra Effect instead.
 */
// export class ThingModifier extends FloatingFeature {
//   apply_to: string[] = [];
//   weapon_limit: WeaponLimitation = new WeaponLimitation();
//   ability_limit: AbilityLimitation = new AbilityLimitation();
//   spell_limit: SpellLimitation = new SpellLimitation();
//   spell_overrides: SpellOverrides = new SpellOverrides();

//   constructor(obj?: any) {
//     super(obj);
//     this.feature_type = "Thing Modifier";
//     if (obj) {
//       this.apply_to = obj.apply_to ? obj.apply_to : [];
//       if (obj.weapon_limit) {
//         this.weapon_limit = new WeaponLimitation(obj.weapon_limit);
//       }
//       if (obj.ability_limit) {
//         this.ability_limit = new AbilityLimitation(obj.ability_limit);
//       }
//       if (obj.spell_limit) {
//         this.spell_limit = new SpellLimitation(obj.spell_limit);
//       }
//     }
//   }

//   toDBObj(): any {
//     const db_obj = super.toDBObj();
//     return {
//       ...db_obj,
//       spell_limit: this.spell_limit.toDBObj(),
//       spell_overrides: this.spell_overrides.toDBObj(),
//     };
//   }

//   copy(copyMe: FloatingFeature, drop_ids: boolean = false): void {
//     super.copy(copyMe, drop_ids);
//     if (copyMe instanceof SpellModifier) {
//       this.safe_copy(copyMe);
//     }
//   }

//   safe_copy(copyMe: SpellModifier) {
//     this.spell_limit = copyMe.spell_limit.clone();
//     this.spell_overrides = copyMe.spell_overrides.clone();
//   }

//   clone(drop_ids: boolean = false): SpellModifier {
//     const new_obj = new SpellModifier();
//     new_obj.copy(this, drop_ids);
//     return new_obj;
//   }
// }

/**
 * This is used to expand the damage types of spells' damaging effects.
 * It can be used to give specific options, or it can be used in a 'learning' way.  
 * The 'learning' way can be done either on a level by level basis, or it can be done in a free way, 
 * and either way it can be made to learn from a single source or any.
 */
export class SpellDamageOptions extends FloatingFeature {
  spell_limit: SpellLimitation = new SpellLimitation(); // These are the spells that are modified
  learning = false;
  damage_type_options: (DamageType | "Selectable")[] = []; // For if it uses specific options
  selectable_key = "";
  learning_limit: SpellLimitation = new SpellLimitation(); // These are the spells that it learns from
  level_by_level = false;

  constructor(obj?: any) {
    super(obj);
    this.feature_type = "Spell Damage Options";
    if (obj) {
      this.spell_limit = obj.spell_limit ? new SpellLimitation(obj.spell_limit) : new SpellLimitation();
      this.learning = obj.learning ? obj.learning : false;
      this.damage_type_options = obj.damage_type_options ? obj.damage_type_options : [];
      this.selectable_key = obj.selectable_key ? obj.selectable_key : "";
      this.learning_limit = obj.learning_limit ? new SpellLimitation(obj.learning_limit) : new SpellLimitation();
      this.level_by_level = obj.level_by_level ? obj.level_by_level : false;
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.spell_limit = obj.spell_limit ? new SpellLimitation(obj.spell_limit) : new SpellLimitation();
  //     this.learning = obj.learning ? obj.learning : false;
  //     this.damage_type_options = obj.damage_type_options ? obj.damage_type_options : [];
  //     this.selectable_key = obj.selectable_key ? obj.selectable_key : "";
  //     this.learning_limit = obj.learning_limit ? new SpellLimitation(obj.learning_limit) : new SpellLimitation();
  //     this.level_by_level = obj.level_by_level ? obj.level_by_level : false;
  //   }
  // }

  toDBObj(): any {
    const db_obj = super.toDBObj();
    return {
      ...db_obj,
      spell_limit: this.spell_limit.toDBObj(),
      learning: this.learning,
      damage_type_options: this.damage_type_options,
      selectable_key: this.selectable_key,
      learning_limit: this.learning_limit.toDBObj(),
      level_by_level: this.level_by_level
    };
  }

  copy(copyMe: FloatingFeature, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    if (copyMe instanceof SpellDamageOptions) {
      this.safe_copy(copyMe);
    } else if (copyMe instanceof SpellModifier || 
      copyMe instanceof SpellsFromList || 
      copyMe instanceof ExtraEffectsFeature || 
      copyMe instanceof ExtraEffectTypeFeature) {
      this.spell_limit = copyMe.spell_limit.clone();
    }
  }

  safe_copy(copyMe: SpellDamageOptions) {
    this.spell_limit = copyMe.spell_limit.clone();
    this.learning = copyMe.learning;
    this.damage_type_options = [...copyMe.damage_type_options];
    this.selectable_key = copyMe.selectable_key;
    this.learning_limit = copyMe.learning_limit.clone();
    this.level_by_level = copyMe.level_by_level;
  }

  clone(drop_ids = false): SpellDamageOptions {
    const new_obj = new SpellDamageOptions();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}
